import { Anchor } from '@mantine/core'
import { formatPhone } from '@phoenix-web/utils/general'

/** KNOCK SUPPORT STRINGS - START **/
export const SUPPORT_PHONE = '8669961695'
export const SUPPORT_HOURS = 'Mon-Fri 9am ET to 6pm ET'
export const SUPPORT_EMAIL = 'hello@knock.com'
export const SCHEDULE_A_CALL_LINK_TEXT = 'Schedule a call'
/** KNOCK SUPPORT STRINGS - END **/

export const TERMS_OF_USE_PATH = `/terms-of-use`
export const CONTACT_US_PATH = `/contact`
export const PRIVACY_POLICY_PATH = `/privacy-policy`
export const COOKIE_POLICY_PATH = `/cookie-policy`
export const DO_NOT_SELL_INFO_PATH = `/privacy-policy#notice-for-california-residents`

/** FOOTER STRINGS - START */
export const FOOTER_LINKS = [
  {
    link: CONTACT_US_PATH,
    label: 'Contact Us',
    target: '_blank',
  },
  {
    link: TERMS_OF_USE_PATH,
    label: 'Terms of Use',
    target: '_blank',
  },
  {
    link: PRIVACY_POLICY_PATH,
    label: 'Privacy Policy',
    target: '_blank',
  },
  {
    link: COOKIE_POLICY_PATH,
    label: 'Cookie Policy',
    target: '_blank',
  },
  {
    link: DO_NOT_SELL_INFO_PATH,
    label: 'Do Not Sell My Information',
    target: '_blank',
  },
] as const

export const KNOCK_LENDING_NMLS_ID = '1958445'
export const KNOCK_LENDING_NMLS = `Knock Lending LLC, NMLS #${KNOCK_LENDING_NMLS_ID}`
export const COPYRIGHT = `© ${new Date().getFullYear()} Knockaway, Inc.  All rights reserved.`
export const FOOTER_EQUAL_HOUSING = 'Equal Housing Opportunity'
export const FOOTER_COMPANY = (
  <>
    Knock Lending LLC
    <br />
    3715 Northside Pkwy, Building 100, Suite 500, Atlanta, GA 30327
    <br />
    <Anchor href={`tel:${SUPPORT_PHONE}`} className="simple-link">
      {formatPhone(SUPPORT_PHONE)}
    </Anchor>
  </>
)

export const FOOTER_LEGAL_STATEMENT_ARR = [
  'Please be advised that Knock Lending, LLC and Knock Property 1, LLC are wholly owned subsidiaries of Knockaway, Inc. (collectively "Knock") and you are NOT required to transact with any of these entities as a condition of working with Knock.',
  'Knock Property 1, LLC issues a Knock Purchase Offer ("KPO") on qualifying properties and charges a contract fee in connection with the KPO.',
  'Equal housing lender. Make sure you understand the features associated with the loan program you choose, and that it meets your unique financial needs. This is not a credit decision or a commitment to lend. Eligibility is subject to completion of an application and verification of home ownership, occupancy, title, income, employment, credit, home value, collateral, and other underwriting requirements as determined by Knock Lending, LLC.',
]
/** FOOTER STRINGS - END */
